import { ILayerListHeaderProps } from "../../types";

export type LayerListSearchProps = Pick<
  ILayerListHeaderProps,
  "isDisabled" | "searchMode" | "searchFilter" | "setSearchFilter" | "setSearchMode" | "selected"
>;

export enum SearchMode {
  Layers = "Layers",
  Objects = "Objects",
  Selection = "Selection",
}
